(() => {
  const debounce = (f) => {
    let timer = null;
    return () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      timer = setTimeout(() => {
        f();
      }, 200);
    };
  };

  const ready = (fn) => {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  };

  const reloadCartDrawerRecommendationWidget = debounce(() => {
    const root = document.querySelector(".cart--root");
    if (!root) {
      return;
    }
    const containers = root.querySelectorAll("div[data-personalization-id]");
    if (!containers.length) {
      return;
    }
    containers.forEach((container) => {
      const id = container.dataset.personalizationId;
      if (!id) {
        return;
      }
      if (!window["pz-recommendations"]) {
        return;
      }
      window["pz-recommendations"].remove(id);
      window["pz-recommendations"].initialRecommendation(id);
    });
  });

  const reloadProductPageRecommendationWidget = debounce(() => {
    const root = document.querySelector("main");
    if (!root) {
      return;
    }
    const containers = root.querySelectorAll("div[data-personalization-id]");
    if (!containers || !containers.length) {
      return;
    }
    containers.forEach((container) => {
      const id = container.dataset.personalizationId;
      if (!id) {
        return;
      }
      if (!window["pz-recommendations"]) {
        return;
      }
      window["pz-recommendations"].remove(id);
      window["pz-recommendations"].initialRecommendation(id);
    })
  });

  const init = () => {
    document.addEventListener('cart:updated', () => {
      reloadCartDrawerRecommendationWidget();
    })
    document.addEventListener("apz:added", () => {
      if (window.theme?.partials?.OffCanvas?.state !== "right-open") {
        window.theme?.partials?.OffCanvas?.openRight?.();
      }

      setTimeout(() => {
        window.theme?.partials?.Cart?.updateAllHtml(() => {
          const cartitems = document.querySelectorAll('.cart--body .cart--item');
          window.theme?.partials?.Cart?.updateAllHasItems(cartitems.length)
        });  
      }, 100)

      setTimeout(() => {
        fetch(window.Shopify.routes.root + 'cart.json').then(res => {
          res.json().then(cart => {
            const itemCount = cart.item_count
            const cartExternalTotalItemsContainers = document.querySelectorAll('.cart--external--total-items')
            if (cartExternalTotalItemsContainers.length && itemCount) {
              cartExternalTotalItemsContainers.forEach(cartExternalTotalItems => {
                cartExternalTotalItems.innerText = itemCount
                if (cartExternalTotalItems.style.display === 'none') {
                  cartExternalTotalItems.style.display = 'inline'
                }
                if (cartExternalTotalItems.parentNode.style.display === 'none') {
                  cartExternalTotalItems.parentNode.style.display = 'inline'
                }
              })
            }
          })
        })
      }, 100)
      
    });

ready(() => {
    const variant =  document.querySelector("#metafield-color-variants");
    if(variant !== null && variant !== undefined )
    {
        variant.addEventListener("click", (event) =>
        {
            const parent = event.target.closest("div[data-product_handle]");
            const handle = parent?.dataset?.product_handle;
            const productId = productColorMap[handle]?.[0]
            if (!productId) {
                return;
            }
            window.ShopifyAnalytics.meta.product.id = productId;
            reloadProductPageRecommendationWidget();
        });
    }        
});
};
init();
})();
